import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllwizardThunk = createAsyncThunk(
    'wizard/getAllSchedule',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllwizardEnq(config);
            //   console.log("nnnnn",response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getwizardStatisticsThunk = createAsyncThunk(
    'wizard/getwizardStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getwizardEnqStatistics(config);
              console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const wizardDetailsThunk = createAsyncThunk(
    'wizard/wizardDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getwizardDetails(id);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportwizardThunk = createAsyncThunk(
    'order/exportwizardThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllwizardEnq(config);
            //   console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deletewizardThunk = createAsyncThunk(
    'order/deleteorder',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deletewizardEnq(id?.id ?? id, id?.password);
            dispatch(setwizardrefresh())
            toast.success('wizard enquiry deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete wizard enquiry')
        }
    }
);

export const deleteProductFromwizardThunk = createAsyncThunk(
    'wizard/deleteprofromwizard',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteProductFromwizardenq(data);
            dispatch(setwizardrefresh())
            toast.success('product deleted from enquiry  successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete product')
        }
    }
);

export const updateProductFromWizardThunk = createAsyncThunk(
    'order/updateProductFromSchedule',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateProductFromwizardenq(data);
            dispatch(setwizardrefresh())
            toast.success('product updated from enquiry  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to update product')
        }
    }
);

export const getAlterProductsThunk = createAsyncThunk(
    'wizard/getAlterProductsThunk  ',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getWizardAlternateProducts(data);
            console.log(response.data); 
            
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getMatchedProductsThunk = createAsyncThunk(
    'wizard/getMatchedProductsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getMatchedProducts(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getSuppliersThunk = createAsyncThunk(
    'wizard/getSuppliersThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getSuppliers(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'Failed to load suppliers');
            return rejectWithValue(error?.response?.data);
        }
    }
);


export const createwizardQuoteThunk = createAsyncThunk(
    'wizard/createwizardQuoteThunk',  
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.createwizardQoute(data);
            console.log(response.data);
            dispatch(setwizardrefresh())
            toast.success('quote updated successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong')
        }
    }
);


const wizardenqSlice = createSlice({
    name: 'wizard',
    initialState: {
        wizardenquiry: [],
        wizardEnquiryDetails: {},
        wizardenquiryStatistics: {
            data: {},
            loading: false
        },
        suppliers:{
            data:[],
            loading:false
        },
        macthedProducts:[],
        refresh: false,
        loading: false,
        alterProducts:{},
        alterLoading:false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setwizardrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setwizardPage: (state, action) => {
            state.page = action.payload
        },
        setwizardSearch: (state, action) => {
            state.search = action.payload
        },
        setwizardStatus: (state, action) => {
            state.status = action.payload
        },
        setwizardFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setwizardToDate: (state, action) => {
            state.toDate = action.payload
        },
        setwizardSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setwizardData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        },
        deleteAlterProduct: (state, action) => {
            const partNumberToRemove = action.payload; 
        
            state.alterProducts.alternateProducts = state.alterProducts.alternateProducts?.filter(
                (i) => {
                    const productNumber = Array.isArray(i?.productOverview?.productNumber)
                        ? i.productOverview.productNumber.join("") 
                        : i?.productOverview?.productNumber; 
        
                    return productNumber !== partNumberToRemove; 
                }
            );
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllwizardThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllwizardThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.wizardenquiry = action.payload;
            })
            .addCase(getAllwizardThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getAlterProductsThunk.pending, (state) => {
                state.alterLoading = true;
            })
            .addCase(getAlterProductsThunk.fulfilled, (state, action) => {
                state.alterLoading = false;
                state.alterProducts = action.payload
            })
            .addCase(getAlterProductsThunk.rejected, (state, action) => {
                state.alterLoading = false;
            })

            //details
            .addCase(wizardDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(wizardDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.wizardEnquiryDetails = action.payload;
            })
            .addCase(wizardDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportwizardThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportwizardThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportwizardThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getwizardStatisticsThunk.pending, (state) => {
                state.wizardenquiryStatistics.loading = true;
            })
            .addCase(getwizardStatisticsThunk.fulfilled, (state, action) => {
                state.wizardenquiryStatistics.loading = false;
                state.wizardenquiryStatistics.data = action.payload
            })
            .addCase(getwizardStatisticsThunk.rejected, (state, action) => {
                state.wizardenquiryStatistics.loading = false
            })

            .addCase(getMatchedProductsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getMatchedProductsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.macthedProducts = action.payload
            })
            .addCase(getMatchedProductsThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getSuppliersThunk.pending, (state) => {
                state.suppliers.loading = true;
                state.suppliers.data = [];
            })
            .addCase(getSuppliersThunk.fulfilled, (state, action) => {
                state.suppliers.loading = false;
                state.suppliers.data = action.payload
            })
            .addCase(getSuppliersThunk.rejected, (state, action) => {
                state.suppliers.loading = false;
            })
    },
});

export const { setwizardrefresh, setwizardPage, setwizardSearch, setwizardStatus, setwizardFromDate, setwizardToDate, setwizardSelectedTab, setwizardData,deleteAlterProduct } = wizardenqSlice.actions
export default wizardenqSlice.reducer;

